/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ExtraFields/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Bluefin from './Bluefin/index'
import No from './No/index'
import Payabli from './Payabli/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ExtraFields({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/Content/ExtraFields"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentProviderValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'provider',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: paymentProviderValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Bluefin'}>
<Bluefin
  viewPath={`${viewPath}/Bluefin`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Payabli'}>
<Payabli
  viewPath={`${viewPath}/Payabli`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}